module.exports = __webpack_public_path__ + "img/Picture15.b03c1079.png";